/** Canonical BuildHof merchant agreement versions — bump when PDF/text changes. */
export const SERVICE_AGREEMENT_META = {
  id: "service_agreement",
  title: "BuildHof Service Agreement",
  summary: "Platform terms for hosting, ordering, and Foundation subscription.",
  price_label: "€99 / month + VAT · 3-month minimum",
  version: "3",
  version_id: "sa-v3-2026-07-26",
  effective_date: "2026-07-26",
  effective_label: "Effective 26 July 2026",
  path: "/legal/service-agreement",
  pdfHref: "/legal/BuildHof_Service_Agreement.pdf",
};

export const DPA_META = {
  id: "data_processing_agreement",
  title: "Data Processing Agreement",
  summary: "How customer and order data is processed on your behalf, including sub-processors.",
  price_label: "Included with Foundation",
  version: "1",
  version_id: "dpa-v1-annex-a",
  effective_date: "2026-07-26",
  effective_label: "Effective 26 July 2026",
  path: "/legal/data-processing-agreement",
  pdfHref: "/legal/Data_Processing_Agreement.pdf",
};

export const PLATFORM_AGREEMENT_BUNDLE_VERSION_ID = "bh-sa-v3+dpa-v1-2026-07-26";

export const PLATFORM_AGREEMENT_DOCS = [SERVICE_AGREEMENT_META, DPA_META];

export function formatAgreementTimestamp(value) {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString(undefined, {
      dateStyle: "medium",
      timeStyle: "short",
    });
  } catch {
    return String(value);
  }
}
